import { render, staticRenderFns } from "./SubCompany.vue?vue&type=template&id=ebead7ca&scoped=true&"
import script from "./SubCompany.vue?vue&type=script&lang=js&"
export * from "./SubCompany.vue?vue&type=script&lang=js&"
import style0 from "./SubCompany.vue?vue&type=style&index=0&id=ebead7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebead7ca",
  null
  
)

export default component.exports